export default __webpack_public_path__ + "static/media/player-valorant-avatar.fad6156d.png";